<template>
  <div>&nbsp;</div>
</template>

<script>
export default {
  name: "PreviewInputPreview"
};
</script>
